module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-flex', {
    attrs: {
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-card', [(_vm.errorMessage) ? _c('div', {
    staticClass: "red--text no-print"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-layout', {
    staticClass: "no-print",
    attrs: {
      "pt-2": "",
      "pr-3": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), (_vm.userRole == _vm.rootRoleName) ? _c('v-btn', {
    staticClass: "primary lighten-1 white--text",
    on: {
      "click": _vm.createDownloadZip
    }
  }, [_c('v-icon', [_vm._v("cloud_download")]), _vm._v("\n            " + _vm._s(_vm.$t('aplix-use-only.usage-report.button-csv-download')) + "\n          ")], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "grey grey--text text--darken-3",
    attrs: {
      "disabled": _vm.isIOS(),
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.printDiv()
      }
    }
  }, [_c('v-icon', [_vm._v("print")]), _vm._v("\n              " + _vm._s(_vm.$t('usage-report.print')) + "\n            ")], 1), _vm._v(" "), (_vm.isIOS()) ? _c('div', [_vm._v("\n              " + _vm._s(_vm.$t('usage-report.can-not-print-ios')) + "\n            ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "no-print",
    attrs: {
      "pt-2": "",
      "pr-3": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    staticClass: "where-select-box",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dateList,
      "item-text": "label",
      "item-value": "value",
      "label": _vm.$t('usage-report.date'),
      "disabled": !_vm.dispFlag
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1), _vm._v(" "), (_vm.userRole == _vm.rootRoleName) ? _c('v-flex', {
    staticClass: "where-select-box",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.summariesPcList,
      "item-text": "organizationName",
      "item-value": "organizationId",
      "label": _vm.$t('aplix-use-only.usage-report.pc-organization'),
      "rules": [function (v) { return !!v || _vm.$t('validate.select'); }],
      "error": _vm.summariesPcListError
    },
    model: {
      value: (_vm.selectPcOrg),
      callback: function($$v) {
        _vm.selectPcOrg = $$v
      },
      expression: "selectPcOrg"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "id": "usage-report"
    }
  }, [_c('v-flex', {
    attrs: {
      "md10": "",
      "offset-md1": ""
    }
  }, [_c('v-card-title', {
    attrs: {
      "pa-0": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md7": ""
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('usage-report.organization-name')))]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.usageSummaries.organizationName))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "offset-md2": "",
      "align-self-center": "true"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('usage-report.date')))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.dispDate))])])], 1), _vm._v(" "), _c('v-card-title', [_c('v-flex', {
    attrs: {
      "md7": "",
      "offset-md1": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('usage-report.total-device-count')))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": "",
      "offset-md2": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.usageSummaries.totalCount) + _vm._s(_vm.$t('usage-report.units')))])])], 1), _vm._v(" "), _c('v-card-title', [_c('h4', [_vm._v(_vm._s(_vm.$t('usage-report.location-count-title')))])]), _vm._v(" "), _c('v-card-actions', [_c('v-data-table', {
    staticClass: "usage-report-table",
    attrs: {
      "headers": _vm.locationListHeaders,
      "items": _vm.locationListTable,
      "no-data-text": _vm.$t('usage-report.no-data-text'),
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.organizationName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.locationName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.deviceCount))])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-title', [_c('h4', [_vm._v(_vm._s(_vm.$t('usage-report.device-count-title')))])]), _vm._v(" "), _c('v-card-actions', [_c('v-data-table', {
    staticClass: "usage-report-table",
    attrs: {
      "headers": _vm.deviceListHeaders,
      "items": _vm.deviceListTable,
      "no-data-text": _vm.$t('usage-report.no-data-text'),
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.organizationName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.locationName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.filtrationSystemName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.uniqueId))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-26e4d568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UsageReport.vue
// module id = 1913
// module chunks = 0